import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/common/pageTitle';
import classNames from 'classnames';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  title: string;
  category: string;
};

const PageTitle: React.FC<ComponentProps> = ({ title, category }) => {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <h1 className={classNames(classes.title, classes.titleLevel2)}>{title}</h1>
        <h4 className={classes.titleSub}>{category}</h4>
      </div>
    </div>
  );
};

export default PageTitle;
